import { cn } from "../../lib/utils.js";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/illustrations/Construction.tsx
const Construction = ({ className, ...props }) => /* @__PURE__ */ jsxs("svg", {
	width: 186,
	height: 109,
	viewBox: "0 0 186 109",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: cn("tw:w-[186px] tw:h-[109px]", className),
	...props,
	children: [/* @__PURE__ */ jsxs("g", {
		clipPath: "url(#clip0_422_37)",
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M94.8798 76.945L89.2019 73.5357L117.248 57.4968L122.92 60.9061L94.8798 76.945Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M122.924 64.1235L94.8842 80.1559V76.9431L122.924 60.9043V64.1235Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M89.2019 76.7336L94.8735 80.1302V76.9111L89.2019 73.5081V76.7336Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M109.538 67.3156L106.066 69.318V22.6146L109.538 20.6121V67.3156Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M102.587 67.3156L106.065 69.318V22.6146L102.587 20.6121V67.3156Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M147.983 105.778L142.311 102.375L170.358 86.3361L176.029 89.7391L147.983 105.778Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M176.031 92.9677L147.985 109V105.781L176.031 89.7422V92.9677Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M142.311 105.573L147.983 108.97V105.75L142.311 102.347V105.573Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M162.642 96.1471L159.164 98.1496V51.4461L162.642 49.4436V96.1471Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M155.691 96.1471L159.162 98.1496V51.4461L155.691 49.4436V96.1471Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M125.658 25.486L129.498 39.6554L142.361 47.057L138.521 32.8875L125.658 25.486Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M178.455 67.8316V55.8738L165.122 48.1997L168.969 62.3755L178.455 67.8316Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M88.9358 4.35645V16.3143L101.443 23.5068L97.5958 9.33738L88.9358 4.35645Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M106.064 14.2081L109.904 28.3776L121.032 34.7779L117.191 20.6085L106.064 14.2081Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M156.669 43.3299L145.542 36.9232L149.382 51.0927L160.515 57.4994L156.669 43.3299Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M97.5974 9.33765L101.444 23.5071L109.907 28.3802L106.067 14.2107L97.5974 9.33765Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M117.193 20.6156L121.033 34.7851L129.496 39.6582L125.655 25.4888L117.193 20.6156Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M137.075 32.0602L140.915 46.2296L149.378 51.0964L145.538 36.9269L137.075 32.0602Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M168.977 62.3705L165.13 48.1947L156.667 43.3279L160.514 57.4974L168.977 62.3705Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M186 63.4949L178.466 67.8293V55.8905L186 51.556V63.4949Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M178.454 55.9112L185.995 51.5577L96.4831 0L88.9358 4.35984L178.454 55.9112Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M44.8793 69.7156C44.8284 69.0819 44.4151 68.48 43.6267 68.0237L27.6102 58.8097C25.7409 57.7324 22.4409 57.8718 20.2791 59.1139L1.7892 69.7537C0.517544 70.4824 -0.0801401 71.4393 0.0152342 72.3265V73.7396C-0.0864984 74.5064 0.320446 75.2541 1.26147 75.7991L17.278 85.0131C19.1473 86.0904 22.4473 85.951 24.6091 84.7089L43.099 74.0691C44.3007 73.3784 44.9047 72.4849 44.8857 71.6421V69.722H44.873L44.8793 69.7156Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M17.2779 83.0012L1.26134 73.7872C-0.607999 72.7099 -0.372751 70.8088 1.78907 69.5668L20.279 58.927C22.4408 57.685 25.7407 57.5455 27.6101 58.6228L43.6266 67.8368C45.4959 68.9141 45.2607 70.8088 43.0989 72.0572L24.609 82.6969C22.4472 83.939 19.1472 84.0785 17.2779 83.0012Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M34.7318 69.5554C34.6619 69.2385 34.5602 68.9281 34.4203 68.6239L24.6985 39.759C24.6985 38.8528 23.395 38.124 21.78 38.124C20.165 38.124 18.8616 38.8592 18.8616 39.759L9.13974 68.6239C8.86634 69.2132 8.72009 69.8343 8.72009 70.468C8.72009 74.5109 14.5634 77.7935 21.78 77.7935C28.9967 77.7935 34.8336 74.5109 34.8336 70.468C34.8336 70.1574 34.7954 69.8532 34.7318 69.5554Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M24.6997 39.759C24.6997 40.6652 23.3962 41.3939 21.7812 41.3939C20.1662 41.3939 18.8628 40.6589 18.8628 39.759C18.8628 38.8592 20.1662 38.124 21.7812 38.124C23.3962 38.124 24.6997 38.8592 24.6997 39.759Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M32.3679 62.5295L30.2506 56.2432C30.2506 56.2432 30.2379 56.2432 30.2315 56.2432C30.3142 56.5093 30.365 56.7755 30.365 57.0543C30.365 59.7095 26.5246 61.8704 21.7877 61.8704C17.0508 61.8704 13.204 59.7158 13.204 57.0543C13.204 56.7882 13.2549 56.522 13.3312 56.2685H13.3121C13.2739 56.3636 11.4173 61.8958 11.1503 62.6816V62.6942C11.1312 62.7449 11.1248 62.7766 11.1248 62.7766C11.004 63.1442 10.9277 63.5181 10.9277 63.9046C10.9277 67.2569 15.7791 69.9818 21.7559 69.9818C27.7327 69.9818 32.6604 67.2632 32.6604 63.9046C32.6604 63.4293 32.5523 62.9667 32.3615 62.5231L32.3679 62.5295Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M28.2115 50.2247H28.2243L26.9971 46.5746C27.048 46.7457 27.0798 46.9168 27.0798 47.0943C27.0798 48.7355 24.7018 50.0726 21.777 50.0726C18.8522 50.0726 16.4742 48.7419 16.4742 47.0943C16.4742 46.8978 16.5123 46.7013 16.5759 46.5112L15.3932 50.0663C15.3169 50.2944 15.2915 50.5289 15.2915 50.7697C15.2915 52.7848 18.2036 54.4198 21.796 54.4198C25.3885 54.4198 28.2942 52.7848 28.2942 50.7697C28.2942 50.5795 28.2624 50.4021 28.2115 50.2183V50.2247Z",
				fill: "white",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", {
		id: "clip0_422_37",
		children: /* @__PURE__ */ jsx("rect", {
			width: 186,
			height: 109,
			fill: "white"
		})
	}) })]
});
//#endregion
export { Construction as default };

//# sourceMappingURL=Construction.js.map